<template>
  <div class="btn-link cursor-pointer" @click.stop="checkStatus">
    <span class="text-truncate">{{ category.toUpperCase() }}# {{ currentSO }}</span>
    <b-modal ref="saveConfirm" :title="label" :hide-footer="true">
      <form @submit.prevent="save">
        <validated-input :label="label" v-model="currentSO" />
        <b-form-group :invalid-feedback="'Supplier Order Number'">
          <label>Query Type</label>
          <b-form-select
            v-model="query_type"
            :options="[
              { text: 'Purchase order from MPower', value: 1 },
              { text: 'Supplier order number', value: 2 },
              { text: 'poSearch', value: 4 }
            ]"
          ></b-form-select>
        </b-form-group>

        <div class="form-group mt-2">
          <button class="btn btn-primary mr-2" type="submit" :disabled="errors.any() || loading">
            <i v-if="loading" class="far fa-spinner-third fa-spin"></i> {{ category == 'so' ? 'Save & ' : '' }}Check
            order status<i
              class="fas fa-question-circle text-light ml-2"
              v-b-popover.hover="{
                content: `PromoStandards credentials missing. <a href='https://docs.mpowerpromo.com/space/MP/918028316/PromoStandards' target='_blank'>Request credentials</a>.`,
                html: true
              }"
            ></i>
          </button>
          <button class="btn btn-secondary" @click="cancel">Cancel</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'OrderPurchaseItemSO',
  props: ['purchaseOrder', 'orderId', 'category', 'value'],
  data() {
    let label = this.category === 'so' ? 'Supplier Order Number' : 'Purchase order from MPower';
    let query_type = this.category === 'so' ? 2 : 1;
    if (this.purchaseOrder.supplier.psCode === 'PROFILL') {
      query_type = 1;
    }
    return {
      label,
      loading: false,
      query_type,
      currentSO: this.value
    };
  },
  computed: {
    options() {
      return this.purchaseOrder.purchaseOrderEmails.map((el) => el.SO);
    }
  },
  methods: {
    async checkStatus() {
      this.$refs.saveConfirm.show();
      this.loading = false;
    },
    cancel() {
      this.$refs.saveConfirm.hide();
      this.loading = false;
    },
    async save() {
      try {
        if (this.category === 'so') {
          this.purchaseOrder[this.category.toUpperCase()] = this.currentSO;
          try {
            this.loading = true;
            await this.http.put(`/orders/${this.orderId}/details/${this.purchaseOrder.friendlyPurchaseOrderDetailId}`, {
              [this.category.toUpperCase()]: this.currentSO
            });
          } catch (e) {
          } finally {
            this.loading = false;
          }
        }
        this.$emit('onChange', { reference_number: this.currentSO, query_type: this.query_type });
      } catch (e) {
      } finally {
        this.cancel();
      }
    }
  }
};
</script>
